import React from 'react'
import PropTypes from 'prop-types'
import { Switch } from 'react-router-dom'
import { AdminProvider } from '@layout/AdminProvider'
import {
  Dashboard,
  Account,
  ChangePassword,
  ProductManagement,
  OrderManagement,
  StockManagement,
  PurchaseOrder,
  Customer,
  DetailCustomer,
  ProductAndStockDetail,
  PurchaseOrderItem,
  SalesOrderItem,
  ProductInformation,
  ProductInformationDetail,
  PurchaseOrderItemDetail,
  SalesOrderItemDetail,
  BankAccount,
  SetupCourier,
  Notifications,
  Members,
  MemberDetails,
  TopUp,
  BalanceLog,
  CommissionReport,
  OrderManagementDetail,
  PointReward,
  MyReward,
  MemberPurchaseReports,
  MemberSalesReports,
  PreOrder,
  DetailPurchaseReports,
  DetailSalesReports,
  PurchasePreOrder,
  DetailPreOrder,
  OrderChannel,
  MemberVisit,
} from '@containers/Pages/asyncPage'
import PrivateRoute from '@components/PrivateRoute'
import application from '@config/application'
import NotFound from '@containers/Pages/NotFound'
import { useFeature } from '@hooks/useFeature'

const basePath = application.prefix + application.path

const AdminRoutes = ({ history }) => {
  const { isPreOrder, isMemberReports, isMemberVisit } = useFeature()
  return (
    <AdminProvider history={history}>
      <Switch>
        <PrivateRoute path={`${basePath}/dashboard`} component={Dashboard} />
        <PrivateRoute path={`${basePath}/account`} component={Account} />
        <PrivateRoute
          path={`${basePath}/change-password`}
          component={ChangePassword}
        />
        <PrivateRoute path={`${basePath}/balance-log`} component={BalanceLog} />
        {(JSON.parse(localStorage.getItem('payload'))?.benefit_type || '')
        !== 'Discount' && (
        <PrivateRoute
          path={`${basePath}/commission-report`}
          component={CommissionReport}
        />
        )}
        <PrivateRoute
          exact
          path={`${basePath}/purchase-order-items`}
          component={PurchaseOrderItem}
        />
        <PrivateRoute
          path={`${basePath}/purchase-order-items/details`}
          component={PurchaseOrderItemDetail}
        />
        {JSON.parse(localStorage.getItem('payload'))?.is_have_childrens && (
          <PrivateRoute
            exact
            path={`${basePath}/sales-order-items`}
            component={SalesOrderItem}
          />
        )}
        {JSON.parse(localStorage.getItem('payload'))?.is_have_childrens && (
          <PrivateRoute
            path={`${basePath}/sales-order-items/details`}
            component={SalesOrderItemDetail}
          />
        )}
        <PrivateRoute
          exact
          path={`${basePath}/product-management`}
          component={ProductManagement}
        />
        <PrivateRoute
          path={`${basePath}/product-management/details`}
          component={ProductAndStockDetail}
        />
        <PrivateRoute
          exact
          path={`${basePath}/order-management`}
          component={OrderManagement}
        />
        <PrivateRoute
          path={`${basePath}/order-management/details`}
          component={OrderManagementDetail}
        />
        <PrivateRoute
          path={`${basePath}/stock-management`}
          component={StockManagement}
        />
        <PrivateRoute
          path={`${basePath}/purchase-order`}
          component={PurchaseOrder}
        />
        <PrivateRoute exact path={`${basePath}/customers`} component={Customer} />
        <PrivateRoute
          path={`${basePath}/customers/details`}
          component={DetailCustomer}
        />
        <PrivateRoute
          exact
          path={`${basePath}/product-information`}
          component={ProductInformation}
        />
        <PrivateRoute
          path={`${basePath}/product-information/details`}
          component={ProductInformationDetail}
        />
        <PrivateRoute
          path={`${basePath}/bank-accounts`}
          component={BankAccount}
        />
        {!JSON.parse(localStorage.getItem('payload'))?.dropship && (
        <PrivateRoute
          path={`${basePath}/setup-courier`}
          component={SetupCourier}
        />
        )}
        <PrivateRoute
          path={`${basePath}/notifications`}
          component={Notifications}
        />
        {JSON.parse(localStorage.getItem('payload'))?.is_have_childrens && (
        <PrivateRoute exact path={`${basePath}/members`} component={Members} />
        )}
        {isMemberVisit && (
        <PrivateRoute
          exact
          path={`${basePath}/members/member-visit`}
          component={MemberVisit}
        />
        )}
        <PrivateRoute
          exact
          path={`${basePath}/members/:id`}
          component={MemberDetails}
        />
        <PrivateRoute path={`${basePath}/top-up`} component={TopUp} />
        <PrivateRoute path={`${basePath}/point-reward`} component={PointReward} />
        <PrivateRoute path={`${basePath}/my-reward`} component={MyReward} />
        {isMemberReports && (
        <PrivateRoute
          exact
          path={`${basePath}/member-purchase-reports`}
          component={MemberPurchaseReports}
        />
        )}
        {isMemberReports && (
        <PrivateRoute
          exact
          path={`${basePath}/member-purchase-reports/:id`}
          component={DetailPurchaseReports}
        />
        )}
        {isMemberReports && (
        <PrivateRoute
          exact
          path={`${basePath}/member-sales-reports`}
          component={MemberSalesReports}
        />
        )}
        {isMemberReports && (
        <PrivateRoute
          exact
          path={`${basePath}/member-sales-reports/:id`}
          component={DetailSalesReports}
        />
        )}
        {isPreOrder && (
          <PrivateRoute
            exact
            path={`${basePath}/pre-order`}
            component={PreOrder}
          />
        )}
        {isPreOrder && (
        <PrivateRoute
          exact
          path={`${basePath}/pre-order/details`}
          component={PurchasePreOrder}
        />
        )}
        {isPreOrder && (
        <PrivateRoute
          exact
          path={`${basePath}/sales-order-items/pre-order`}
          component={PurchasePreOrder}
        />
        )}
        {isPreOrder && (
        <PrivateRoute
          exact
          path={`${basePath}/pre-order/:id`}
          component={DetailPreOrder}
        />
        )}
        <PrivateRoute
          exact
          path={`${basePath}/order-channel`}
          component={OrderChannel}
        />
        {/* <PrivateRoute path={`${basePath}/members/:id/details`} component={PurchaseOrderItemDetail} /> */}

        {/* <PrivateRoute path={`${application.path}/billing`} component={asyncPage('Billing')} /> */}
        <PrivateRoute component={NotFound} />
      </Switch>
    </AdminProvider>
  )
}

AdminRoutes.propTypes = {
  history: PropTypes.any.isRequired,
}

export default AdminRoutes
